import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    const submitWidgetForm = () => {
      const $form = $('.widget-form');
      const formData = new FormData($form[0]);

      if (formData.get('image').name === '') {
        formData.delete('image');
      }
      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: formData,
        processData: false,
        contentType: false,
        success: (widgetCode) => {
          if ($('.widget-form__questionnaires-selection').length > 0) {
            $('.widget-form__questionnaires-selection').toggleClass(
              'hide',
              $('input[name="widget_data[paid]"]:checked').val() === 'true'
            );
          }
          $('.widget-container').html(widgetCode);
          $('.widget-form__code-field').val(widgetCode);
        },
      });
    };

    $(document).on(
      'change',
      `select[name="widget_data[width]"],
     input[name="widget_data[paid]"],
     input[name="widget_data[show_avatar]"],
     select[name="widget_data[background]"],
     .field--widget-questionnaire-id,
     .widget-form__custom-bg`,
      () => {
        submitWidgetForm();
      }
    );

    $(document).on('click', '.p-button--update-widget-header-text', () => {
      submitWidgetForm();

      return false;
    });

    $(document).on('change', 'select[name="widget_data[background]"]', (e) => {
      if ($(e.target).val() === '0') {
        $('.widget-form__custom-bg').css('display', 'flex');
      } else {
        $('.widget-form__custom-bg').hide();
      }
    });
  });

  $(document).on('click', '.mobile-widget-preview__button', (e) => {
    const $container = $('.mobile-widget-preview').find('.widget-container');
    $container.toggleClass('widget-container--expanded');
    $('.mobile-widget-preview__button').toggleClass('mobile-widget-preview__button--active');
  });
});
